import React from 'react';
import { motion } from 'framer-motion';
import { FileTextIcon, ZapIcon, MapPinIcon, SparklesIcon, ShieldCheckIcon, LockIcon, CreditCardIcon, SmartphoneIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const chips = [{
  icon: FileTextIcon,
  label: '100% PDF'
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}, {
  icon: MapPinIcon,
  label: 'Para Argentina'
}, {
  icon: SparklesIcon,
  label: 'Emprendedoras'
}];
const trust = [{
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}, {
  icon: LockIcon,
  label: 'Pago seguro'
}, {
  icon: CreditCardIcon,
  label: 'Mercado Pago'
}, {
  icon: SmartphoneIcon,
  label: 'Android & iOS'
}];
export function Hero() {
  return <header className="bg-radial-glow relative overflow-hidden" data-id="element-83" data-mp="nczvdd79wfys">
      <div className="mx-auto max-w-4xl px-5 pb-6 pt-7 text-center sm:pt-16" data-id="element-84" data-mp="3d1im5e7m7kpj">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="my-1.5 text-[10px] font-extrabold uppercase tracking-[0.25em] text-bordo-light" data-id="element-85" data-mp="3czfm01cr0b73">
          🏆 SIGMA SMART™
        </motion.p>

        <span className="font-display text-[24px] font-extrabold text-plata-soft sm:text-[30px]" style={{
        fontSize: "26px"
      }} data-id="element-86" data-mp="3o6kh1mlj0k78">
          El paso a paso para tu negocio de tejido,
todo resuelto acá
        </span>

        <motion.h1 initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="pb-2.5 pt-3 text-center font-display text-[20px] font-bold tracking-tight text-silver-shine sm:text-[26px]" style={{
        color: "#CF4D61"
      }} data-id="element-87" data-mp="3e7uwfm28wlna">
          AMIGURUMI  BUSINESS  PACK
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} className="relative mx-auto w-full max-w-md" data-id="element-88" data-mp="2viy3pmmhy176">
          <div aria-hidden="true" className="absolute inset-0 -z-10 mx-auto h-64 w-64 translate-y-6 rounded-full bg-bordo/40 blur-3xl" data-id="element-89" data-mp="2ll0i76w0uii9" />
          <img src="https://cdn.magicpatterns.com/uploads/wpUCjJFK2pCfU7ZzAZBWAt/ChatGPT_Image_4_ago_2026,_16_21_28.png" alt="Amigurumi Business Pack — 12 tomos y 5 bonos en formato digital" className="animate-floaty mx-auto h-[300px] w-[300px] max-w-full rounded-2xl object-contain" data-id="element-90" data-mp="nbl42pi3sock" />
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.05
      }} className="mt-4 text-xs font-semibold uppercase tracking-[0.18em] text-plata-deep" style={{
        fontSize: "10px",
        paddingTop: "16px",
        marginTop: "-15px",
        marginBottom: "-15px"
      }} data-id="element-91" data-mp="1b0dt020b5vxo">
          El sistema N°1 para tejedoras que quieren vivir de sus amigurumis en Argentina
        </motion.p>

        <div className="mt-7" data-id="element-92" data-mp="3lu9wv02xxwap">
          <CTAButton href="#value" data-id="element-93" data-mp="3hrd9yx6dbe0y">Ver la oferta</CTAButton>
          <p className="mx-auto mt-4 max-w-2xl text-[14px] text-white/70 sm:text-lg" data-id="element-94" data-mp="3hpsff7k1zv33">
            Todo lo que necesitás para tejer con acabado profesional, cobrar el precio justo y
            llenar tu agenda de encargos. Sin improvisar. Sin regalar tu trabajo en cada venta.
          </p>

          <motion.h2 initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="mx-auto mt-7 max-w-2xl text-[16px] font-bold text-plata-soft sm:text-xl" style={{
          color: "#A92347"
        }} data-id="element-95" data-mp="2697ouo46fa0r">
            Técnica Pro + Costos Reales ARG + Fotografía con Celular + Instagram &amp; Ventas + Meta
            Ads + Proveedores
          </motion.h2>

          <div className="mt-7 flex flex-wrap justify-center gap-2.5" data-id="element-96" data-mp="2p1jvhn1v4xgp">
            {chips.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5 rounded-full border border-white/10 bg-white/5 px-3.5 py-1.5 text-xs font-semibold text-white/80" data-id="element-97" data-mp="2tysfzuahhdl4">
                <Icon className="h-3.5 w-3.5 text-plata" aria-hidden="true" data-id="element-98" data-mp="4bdxzj5xmfq7" />
                {label}
              </span>)}
          </div>

          <p className="mt-5 whitespace-pre-line text-sm font-semibold text-white/50" data-id="element-99" data-mp="3vgvt2gjt4v0g">
            {'12 Tomos · 5 Bonos · +100 páginas\n· TODO RESUELTO ·'}
          </p>
        </div>

        <div className="my-4 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs font-medium text-white/50" data-id="element-100" data-mp="9a79x75klyo9">
          {trust.map(({
          icon: Icon,
          label
        }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-101" data-mp="3crftbvfy56l3">
              <Icon className="h-4 w-4 text-plata" aria-hidden="true" data-id="element-102" data-mp="3cpctykswm13p" />
              {label}
            </span>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.05
      }} className="mt-4 inline-flex items-center gap-2 rounded-full border border-bordo-soft/60 bg-bordo/25 px-4 py-1 text-xs font-bold uppercase tracking-wide text-plata-soft" data-id="element-103" data-mp="3mp3mwi1tg81o">
          🔥 Oferta por lanzamiento — Este precio cierra pronto · Luego aumenta a $54.990
        </motion.div>
      </div>
    </header>;
}